import { render, staticRenderFns } from "./GstPayWithHoldingDetail.vue?vue&type=template&id=30317891&scoped=true"
import script from "./GstPayWithHoldingDetail.vue?vue&type=script&lang=js"
export * from "./GstPayWithHoldingDetail.vue?vue&type=script&lang=js"
import style0 from "./GstPayWithHoldingDetail.vue?vue&type=style&index=0&id=30317891&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30317891",
  null
  
)

export default component.exports